import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import IconsMixin from '@/mixins/IconsMixin';
import ProductMixin from '@/mixins/ProductMixin';
import {
    ProductServiceItem,
    Product,
    FieldName,
} from '../ProductsAndServicesModels';
import ContentCard from "@/products-and-services/products-type/ContentCard.vue";

@Component({
    components: {
        ContentCard,
    },
})
export default class StaticIpAddresses extends Mixins(IconsMixin, ProductMixin) {
    @Prop({type: Array, required: false})
    private products!: Product[];
    @Prop({type: String, required: false})
    private serviceTypeId!: string;
    @Prop({type: String, required: false})
    private serviceId!: string;
    @Prop({type: String, required: false})
    private serviceCatId!: string;
    @Prop({type: Boolean, required: false, default: false})
    private isFullCart!: boolean;

    private oneStaticIP = 1;
    private multipleStaticIPs = 2;
    private selectedValue: string = '0';
    private notSaving = true;

    @Watch("products")
    checkProducts() {
        if (this.notSaving) {
            this.setValues();
        }
    }

    created() {
        this.setValues();
    }

    get inCart(): boolean {
        return this.isInCart(this.getSelectedServiceProduct(this.products[0])) || this.isInCart(this.getSelectedServiceProduct(this.products[1]));
    }

    getSelectedDisplayedProduct(index: number): ProductServiceItem {
        let totalCost = parseInt(this.products[0]?.amount?.toString() ?? 0, 10);

        if (parseInt(this.selectedValue, 10) > 1) {
            totalCost += parseInt(this.products[1]?.amount?.toString() ?? 0, 10);
        }

        const productIndex = (index || 0) > 1 ? 1 : 0;
        const {serviceId, serviceTypeId, serviceCatId, productId, productCatId} = this.getSelectedServiceProduct(this.products[productIndex]);
        return {
            index: 0,
            serviceId, serviceTypeId, serviceCatId, productId, productCatId,
            name: "Static IPs",
            description: `<p>1 Static IP &mdash; $${this.products[0].amount}<br />2 up to 5 Static IPs &mdash; $${this.products[1].amount} flat fee for all</p>`,
            totalAmount: totalCost,
            imageUrl: this.products[0].imageUrl,
            learnMoreUrl: this.products[0].learnMoreUrl
        };
    }

    getSelectedServiceProduct(product: Product) {
        const {productId, productCatId} = product;
        const {serviceTypeId, serviceId, serviceCatId} = this;
        return {serviceId, serviceTypeId, serviceCatId, productId, productCatId}
    }

    setValues() {
        const selectedItems = this.products.filter(p => p.value);
        if (selectedItems.length > 0) {
             const reducedQuantity = selectedItems.reduce<number>((builder: number, product: Product) => {
                const staticIPItemValue = (this.jsonParseFromValue(product.value));
                const value = `${staticIPItemValue[0].value}`.substr(0, 1);
                const parsedValue = parseInt(value, 10);
                return builder + parsedValue;
            }, 0);
            this.selectedValue = reducedQuantity.toString();
        } else {
            this.selectedValue = "0";
        }
    }

    async save(index: string) {
        if (!index) {
            return;
        }

        this.notSaving = false;
        const staticIPCount = parseInt(index, 10);
        const multipleStaticIPs = staticIPCount > 1;

        const noRefetch = true;
        await this.remove(noRefetch);

        if (multipleStaticIPs) {
            const ipCount = staticIPCount - 1;
            await this.addItemToCart(ipCount, this.multipleStaticIPs, noRefetch);
        }

        const ipCount = 1;
        await this.addItemToCart(ipCount, this.oneStaticIP);

        this.notSaving = true;
        this.setValues();
    }

    async remove(noRefetch = false) {
        await this.removeFromCart({
            ...this.getSelectedDisplayedProduct(this.oneStaticIP),
            noRefetch: true
        });
        await this.removeFromCart({
            ...this.getSelectedDisplayedProduct(this.multipleStaticIPs),
            noRefetch
        });
    }

    private async addItemToCart(staticIPCount: number, staticIpProductIndex: number, dontRefetch: boolean = false) {
        let value = this.jsonStringifyValue([{
            field: FieldName.NUMBER_OF_STATIC_IP_ADDRESS,
            value: staticIPCount
        }]);
        await this.addToCart({...this.getSelectedDisplayedProduct(staticIpProductIndex), value, noRefetch: dontRefetch});
    }
}
